// import { config } from 'dotenv';
// config();

const configuration = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  };
  console.log("config",process.env);
  export default configuration;